import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class NewCommunityResourcesService {
  constructor(private base: BaseService) {}

  createResources(data) {
    return this.base.post("/api/create-community-resources", data);
  }

  communityMentionList(search: any) {
    const url = `/api/community-mention-list?search=${search}`;
      return this.base.get(url);
  }


  updateResources(data) {
    return this.base.post("/api/update-community-resources", data);
  }

  editResources(data) {
    return this.base.post("/api/edit-community-resources",data);
  }

  resourcesMaster() {
    return this.base.get("/api/community-resources-master");
  }

  deleteResource(id) {
    return this.base.post("/api/we-community-newsfeed-update-status", { id: id });
  }

 
}
